import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { DescriptionDetailedCategory } from '../../description-detailed/description-detailed-category.component';
import { SliderOptions } from '../../slider/slider/slider.component';
import { Device } from '../../../model/Device';

@Component({
    selector: 'room-type-modal-content',
    template: `
        <div class="room-type-images">
            <!-- TODO MIGRAR A SLIDER PRO -->
            <slider *ngIf="images" [options]="sliderOptions">
                <slider-item *ngFor="let image of images" class="slider-item">
                    <img [src]="mediaPictureService.getMediaUrl(image, '690x388')" [ngStyle]="{width: '690px', height: '388px'}" alt="" loading="lazy">
                </slider-item>
            </slider>
        </div>

        <div class="room-type-content">
            <p class="room-type-title -eva-3-bold">{{title}}</p>
            <span *ngIf="subTitle" class="room-type-subtitle" [innerHTML]="subTitle"></span>
            <span *ngIf="text" class="room-type-description" [innerHTML]="text"></span>
            <div *ngIf="amenities">
                <p *ngIf="amenities.title?.text?.value" class="room-type-amenities-title -eva-3-bold">{{amenities.title.text.value}}</p>
                <ul *ngIf="amenities.items && amenities.items.length > 0" class="room-type-amenities-items"
                    [ngClass]="{'has-bullet': amenities.has_bullet}">
                    <li *ngFor="let item of amenities.items" class="room-type-amenity-item">
                        <description-detailed-item [item]="item"></description-detailed-item>
                    </li>
                </ul>
            </div>
        </div>
    `,
    styleUrls: ['./room-type-modal-content.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RoomTypeModalContentComponent implements OnInit {
    @Input() title: string;
    @Input() subTitle: string;
    @Input() text: string;
    @Input() amenities: DescriptionDetailedCategory;
    @Input() images: string[];
    @Input() device: Device;

    sliderOptions: SliderOptions;

    constructor(public mediaPictureService: MediaPictureService) { }

    ngOnInit() {
        this.sliderOptions = {
            id: 'card-images-carrousel',
            show_arrows: this.device.type !== 'MOBILE',
            show_dots: true,
            dots_inside: true,
            items_to_show: 1,
            items_length: this.images.length,
            max_fixed_width: 690,
            mobile_card_size: 100,
            items_to_move: 1,
            space_between: 0,
            arrows_size: '-md',
            show_loader: true,
            deactivate_touch: this.device.type !== 'MOBILE',
            arrows_inner_container: true,
            lighten: true
          }
    }
}